import type { MonthCaptionProps } from "react-day-picker";

import { useTranslations } from "@ui/providers/useTranslations";

import type { Month } from "../DatePicker.types";

import styles from "./CustomMonthCaption.module.scss";

export const CustomMonthCaption = (props: MonthCaptionProps) => {
  const { __ } = useTranslations();

  const monthIndex = props.calendarMonth.date.getMonth() as Month;

  return <div className={styles.monthCaption}>{__(`daypicker.month.${monthIndex + 1}`)}</div>;
};
